import * as angular from "angular";
import * as _ from "lodash";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";
import {PricePlanRequestsService} from "../price-plan/services/price-plan-requests.service";

angular
  .module('bringoz.admin.contracts')
  .config(ContractsConfig);

/* @ngInject */
function ContractsConfig($stateProvider) {
  $stateProvider
    .state('contracts', {
      parent: 'bringoz.site',
      url: '/contracts',
      abstract: true,
      template: '<contracts></contracts>',
      controller: function (site) {
      }
    })

    .state('contracts.contracts-table', {
      template: '<contracts-table-view></contracts-table-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Contracts", state: "contracts"});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
    })

    .state('contracts.account-contracts-table', {
      url: ':accountId',
      template: '<contracts-table-view account-id="vm.accountId"></contracts-table-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams) {
        this.accountId = $stateParams.accountId

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Contracts", state: "contracts"});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
    })

    .state('contract', {
      parent: 'bringoz.site',
      url: '/contract/:contractId/:programId',
      controllerAs: 'vm',
      abstract: true,
      template: '<contract-view contract="vm.contract" selected-program-id="vm.selectedProgramId"></contract-view>',
      controller: function ($scope, contract, triBreadcrumbsService, servicesProgramTypes, programId, $stateParams, site) {

        this.contract = contract;
        this.selectedProgramId = programId;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: contract.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Contracts', state: 'contracts.account-contracts-table'});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        contract: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getBundleById($stateParams.contractId);
        },
        servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSiteServicesProgramType();
        },
        programId: function ($stateParams, servicesProgramTypes, contract) {
          let programId;
          if (!!$stateParams.programId) {
            programId = $stateParams.programId;
          } else if (Object.keys(servicesProgramTypes).length) {
            const enabledProgramId = _.find(contract.entryList, p => {
              return p.type === servicesProgramTypes.Delivery && p.enabled;
            }).id;
            programId = !!enabledProgramId ? enabledProgramId : _.find(contract.entryList, (p) => p.enabled)?.id;
          } else {
            programId = _.find(contract.entryList, (p) => {
              return p.enabled;
            })?.id
          }

          return programId;
        }
      }
    })
    .state('contract.details', {
      abstract: true,
      url: '/details',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<contract-details selected-program-id="vm.selectedProgramId" contract="vm.contract"></contract-details>',
      controller: function (triBreadcrumbsService, site, contract, programId, $stateParams) {
        this.contract = contract;
        this.selectedProgramId = programId;
      }
    })
    .state('contract.details.service', {
      url: '/service',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pricing-method-view flex program-id="vm.programId" program-setting="vm.programSetting" is-show-rounding-type="true"></program-pricing-method-view>',
          controllerAs: 'vm',
          controller: function (site, $stateParams, contract, programId, servicesProgramTypes) {

            this.programId = programId;

            const programEntry = _.find(contract.entryList, (p) => {
              return p.id === this.programId
            })
            this.programSetting = programEntry?.programSetting;
          }
        }
      }
    })
    .state('contract.details.price', {
      url: '/pricing',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-pricing-view flex program="vm.program" groups="vm.groups" program-id="vm.programId">' +
            '</price-plan-pricing-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('contract.details.quantity', {
      url: '/quantity',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-quantity-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></program-quantity-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['QuantityDiscount'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['QuantityDiscount'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('contract.details.vehicleCharge', {
      url: '/vehicle-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-vehicle-charge-view flex program="vm.program" groups="vm.groups" program-id="vm.programId"></price-plan-vehicle-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['VehicleFactor'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['VehicleFactor'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('contract.details.packageSize', {
      url: '/package-size',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-package-size-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" '
            + 'label-options="vm.labels"></price-plan-package-size-view>',
          controllerAs: 'vm',
          controller: function (program, labels, $stateParams) {
            this.groups = ['PackageSize'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.labels = labels;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['PackageSize'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            },
            labels: function (labelsRequestsService) {
              return labelsRequestsService.getAll();
            }
          }
        }
      }
    })
    .state('contract.details.skills', {
      url: '/skills',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-skills-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-skills-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Skills'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Skills'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups
              );
            }
          }
        }
      }
    })
    .state('contract.details.pod', {
      url: '/pod',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pod-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-pod-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('contract.details.additions', {
      url: '/additions',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-additions-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" site-additions="vm.siteAdditions"></program-additions-view>',
          controllerAs: 'vm',
          controller: function (program, siteAdditions, $stateParams) {
            this.groups = ['Addition'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.siteAdditions = siteAdditions;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              const groups = ['Addition'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            },
            siteAdditions: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteAdditions();
            }
          }
        }
      }
    })
    .state('contract.details.service-time', {
      url: '/service-time',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-service-time-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId"></program-service-time-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Additional'];
            this.program = program;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              var groups = ['Additional'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups)
            }
          }
        }
      }
    })
    .state('contract.details.calendar', {
      url: '/calendar',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-calendar program-id="vm.programId"></price-plan-calendar>',
          controllerAs: 'vm',
          controller: function ($stateParams) {
            this.programId = $stateParams.programId
          }
        }
      }
    })
}
